<template>
  <v-form ref="priceListForm" v-model="valid" :lazy-validation="lazy">
    <v-row dense>
      <v-col cols="4">
        <v-text-field
          name="priceListName"
          outlined
          dense
          label="Price List Name"
          v-model="record.Name"
          :rules="inputRules"
        ></v-text-field>
      </v-col>

      <v-col cols="4">
        <v-text-field
          type="number"
          name="priceListDiscount"
          outlined
          dense
          label="Discount %"
          v-model="discountPercent"
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox
          style="margin-top: -2px"
          label="Show when editing a product"
          v-model="showOnProductEdit"
        ></v-checkbox>
      </v-col>

      <v-col cols="12">
        <v-btn
          v-if="docCreate == true"
          color="accent"
          @click="sendData"
          :loading="$store.state.btnLoader"
        >
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>

        <v-btn v-else color="accent" @click="sendData" :loading="loader">
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>
    </v-row>

    <snackbar ref="snackbar"></snackbar>
  </v-form>
</template>


<script>
export default {
  name: "PriceListIndex",
  props: {
    initial: {
      type: Object,
      required: true
    },
    docCreate: {
      type: Boolean
    }
  },
  data: () => ({
    record: {},
    valid: false,
    lazy: false,
    inputRules: [v => !!v || "Required"],
    showOnProductEdit: true,
    discountPercent: 0,
    existing: true,
    loader: false,
    date: new Date().toISOString().substr(0, 10)
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true
    }
  },
  methods: {
    init(val) {
      this.showOnProductEdit = val.showOnProductEdit == 1 ? true : false;
      this.discountPercent = val.discountPercent;
      this.record = { ...val };
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      if (!this.$refs.priceListForm.validate()) {
        this.$refs.snackbar.show("Please fill all required fields", "red");
        return;
      }

      this.loader = true;
      this.record.discountPercent = parseFloat(this.discountPercent);
      this.record.showOnProductEdit = this.showOnProductEdit == true ? 1 : 0;
      this.$store.commit("btnLoader", true);
      this.$emit("data", this.record);
    }
  },
  created() {}
};
</script>